module.exports = __webpack_public_path__ + "static/media/shelf_svg_2.9f013f07.svg";